<template>
  <div class="">
    <div class="search-div">
      <div class="search-content" @click="focus">
        <span class="icon iconfont icon-search"></span>
        <span>搜索</span>
      </div>
    </div>
    <slot name="tabs"></slot>
    <div class="line vux-1px-b"></div>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    type: {
      type: Number,
      default: 1 //  1为主页资讯搜索 2 为病例搜索
    }
  },
  data() {
    return {};
  },
  methods: {
    focus() {
      let vueUrl = {
        name: 'search'
      };
      if (this.type === 2) {
        vueUrl.query = {
          type: 2
        };
      }
      this.$router.push(vueUrl);
    }
  },
  computed: {},
  watch: {},
  components: {},
  created() {}
};
</script>
<style lang="less" scoped>
.search-div {
  padding: 0 0.4rem /* 30/75 */;
  margin-bottom: 0.2rem;
}

.line {
  width: 100%;
  height: 1px;
  // background: #D8D8D8;
}

.search-content {
  width: 100%;
  position: relative;
  background: #f2f2f2;
  border-radius: 0.1067rem /* 8/75 */;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    font-size: 0.4rem /* 30/75 */;
    color: #999999;
    margin-left: 0.0933rem /* 7/75 */;
  }
  .icon-search {
    font-size: 0.5rem;
  }
}
</style>
